/**
 * Program Cards 1038 — BDU Specialisations
 * Centred heading + gradient rule + a wrapping row of tinted programme cards.
 */

export const PROGRAM_CARDS_1038_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Specialisation cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "English",
    meta_parent_title: "",
    meta_description: "",
    meta_duration: "3 Years",
    meta_image: "",
    meta_alt_image: "",
    meta_url: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Specialisations",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Specialisations",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "card_background_color",
      label: "Card tint over the image",
      value: "#222023A1",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023A1",
    },
    {
      fieldName: "cta_text",
      label: "Card CTA label",
      value: "Know more",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Know more",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card background image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload card artwork",
      defaultValue: "",
    },
    {
      header: "Image alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. English",
      defaultValue: "",
    },
    {
      header: "Parent programme (set to render as a specialisation)",
      fieldName: "meta_parent_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Online MA — leave empty for a standalone programme",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Duration",
      fieldName: "meta_duration",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 3 Years",
      defaultValue: "",
    },
    {
      header: "Card URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/online-ma/english",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
